import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=f91c6c7c&scoped=true&"
import script from "./AddAdmin.vue?vue&type=script&lang=js&"
export * from "./AddAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AddAdmin.vue?vue&type=style&index=0&id=f91c6c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91c6c7c",
  null
  
)

component.options.__file = "AddAdmin.vue"
export default component.exports